import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const keywords = [
  "naklejki 3D", "naklejki wypukłe 3D", "doming", "naklejki żywiczne",
  "naklejki epoksydowe", "naklejki poliuretanowe", "naklejki domingowe",
  "naklejki z logo", "naklejki reklamowe 3D", "etykiety 3D",
  "naklejki z żywicą", "naklejki żelowe", "naklejki samoprzylepne 3D",
  "logo wypukłe", "naklejki na produkty", "naklejki trwałe",
  "naklejki odporne na UV", "naklejki premium", "naklejki personalizowane",
  "naklejki dla firm",
];

const SeoContentSection = () => {
  const { t } = useTranslation();
  const usps = t("seoContent.usps", { returnObjects: true }) as string[];

  return (
  <section className="py-12 md:py-20 lg:py-28 bg-background">
    <div className="container mx-auto px-4 max-w-5xl">
      <div className="text-center mb-8 md:mb-12">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
          {t("seoContent.title")}
        </h2>
        <p className="text-muted-foreground text-sm md:text-lg max-w-3xl mx-auto leading-relaxed">
          {t("seoContent.subtitle")}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 md:gap-12 mb-10 md:mb-14">
        <div className="space-y-4">
          <h3 className="text-lg md:text-xl font-semibold text-foreground">
            {t("seoContent.whatTitle")}
          </h3>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
            {t("seoContent.whatP1")}
          </p>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
            {t("seoContent.whatP2")}
          </p>
        </div>

        <div className="space-y-3">
          <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">
            {t("seoContent.featuresTitle")}
          </h3>
          {usps.map((usp) => (
            <div key={usp} className="flex items-start gap-2.5">
              <CheckCircle className="w-4 h-4 text-accent shrink-0 mt-0.5" />
              <span className="text-muted-foreground text-sm md:text-base">{usp}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-10 md:mb-14">
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4">
          {t("seoContent.applicationsTitle")}
        </h3>
        <p className="text-muted-foreground text-sm md:text-base leading-relaxed mb-4">
          {t("seoContent.applicationsP1")}
        </p>
        <p className="text-muted-foreground text-sm md:text-base leading-relaxed">
          {t("seoContent.applicationsP2")}
        </p>
      </div>

      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <Link
          to="/kalkulator"
          className="gradient-gold text-accent-foreground font-bold px-8 py-4 rounded-lg text-base md:text-lg hover:opacity-90 transition-opacity shadow-gold text-center inline-flex items-center justify-center gap-2"
          aria-label={t("seoContent.ctaAria")}
        >
          {t("seoContent.cta")}
          <ArrowRight className="w-5 h-5" />
        </Link>
            <Link
              to="/kalkulator"
              className="border-2 border-border text-foreground font-semibold px-8 py-4 rounded-lg text-base md:text-lg hover:border-accent hover:text-accent transition-colors text-center inline-flex items-center justify-center gap-2"
              aria-label={t("seoContent.orderAria")}
        >
          {t("seoContent.orderCta")}
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>

      {/* Hidden keyword cluster for semantic SEO */}
      <div className="sr-only" aria-hidden="true">
        <p>Słowa kluczowe: {keywords.join(", ")}.</p>
        <p>Naklejki 3D z opcją złocenia. Naklejki wypukłe ze srebrzeniem. Naklejki poliżywiczne. Naklejki w dowolnym kształcie. Naklejki maszynowa produkcja. Naklejki wysokość około 2 mm. Naklejki trwałość 10 lat. Produkcja naklejek doming w Polsce.</p>
      </div>
    </div>
  </section>
  );
};

export default SeoContentSection;
